module.exports = __webpack_public_path__ + "img/web-and-file.2ffe5a0f.png";